/**
 * AmsProjectAudit.amsProjectId is typed as a string but the API sometimes
 * returns it populated as an object (see AmsProjectApprovalList's identical
 * handling) — normalize both shapes to a plain id string.
 */
export const resolveAmsProjectId = (rawProjectId: unknown): string | null => {
  if (!rawProjectId) return null;
  if (typeof rawProjectId === 'object') {
    const obj = rawProjectId as { _id?: string; id?: string };
    return String(obj._id || obj.id || '') || null;
  }
  return String(rawProjectId);
};
